import { Room, RoomEvent, Track } from 'livekit-client';
import { useCallback, useEffect, useState } from 'react';

export const useTrackManagement = (room: Room | null) => {
  const [hostVideoTrack, setHostVideoTrack] = useState<Track | null>(null);
  const [hostAudioTrack, setHostAudioTrack] = useState<Track | null>(null);
  const [hostTracks, setHostTracks] = useState<Track[]>([]);

  const onTrackSubscribed = useCallback((track: Track) => {
    if (track.kind === Track.Kind.Video) {
      setHostVideoTrack(track);
    } else if (track.kind === Track.Kind.Audio) {
      setHostAudioTrack(track);
    }
  }, []);

  useEffect(() => {
    setHostTracks([...(hostVideoTrack ? [hostVideoTrack] : []), ...(hostAudioTrack ? [hostAudioTrack] : [])]);
  }, [hostVideoTrack, hostAudioTrack]);

  useEffect(() => {
    if (!room) return;
  
    room.remoteParticipants.forEach(participant => {
      participant.trackPublications.forEach(publication => {
        if (publication.track) {
          onTrackSubscribed(publication.track);
        }
      });
    });
  
    room.on(RoomEvent.TrackSubscribed, onTrackSubscribed);
    return () => {
      room.off(RoomEvent.TrackSubscribed, onTrackSubscribed);
    };
  }, [room, onTrackSubscribed]);

  return { hostTracks, hostVideoTrack, hostAudioTrack };
};
